import Badge from '../components/Badge'
import BaseProgress from '../components/BaseProgress'
import BaseRadio from '../components/BaseRadio'
import BaseSlider from '../components/BaseSlider'
import BaseSwitch from '../components/BaseSwitch'
import BaseAlert from '../components/BaseAlert'
import BaseButton from '../components/BaseButton'
import BaseInput from '../components/BaseInput'
import BasePagination from '../components/BasePagination'
import Card from '../components/Card'

export default {
  install (Vue) {
    Vue.component(Badge.name, Badge)
    Vue.component(BaseProgress.name, BaseProgress)
    Vue.component(BaseRadio.name, BaseRadio)
    Vue.component(BaseSlider.name, BaseSlider)
    Vue.component(BaseSwitch.name, BaseSwitch)
    Vue.component(BaseAlert.name, BaseAlert)
    Vue.component(Card.name, Card)
    Vue.component(BaseButton.name, BaseButton)
    Vue.component(BaseInput.name, BaseInput)
    Vue.component(BasePagination.name, BasePagination)
  }
}
